// src/api/user.api.js
// ─────────────────────────────────────────────────────────────────────────────
//  All user-management API calls.
// ─────────────────────────────────────────────────────────────────────────────

import api from './axios';

export const getRoleOptionsApi = () => api.get('/users/role-options');

export const getUsersApi = (page = 1, limit = 10, q = '') =>
  api.get('/users', { params: { page, limit, q } });

export const createUserApi = (payload) =>
  api.post('/users', payload);

export const updateUserApi = (id, payload) =>
  api.put(`/users/${id}`, payload);

export const deleteUserApi = (id) =>
  api.delete(`/users/${id}`);
